import { FirebaseApp, getApps } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { Firestore, getFirestore } from 'firebase/firestore'
import { Functions, getFunctions } from 'firebase/functions'
import { FirebaseStorage, getStorage } from 'firebase/storage'
import {
  auth,
  firestore,
  functions,
  storage,
} from '../AAinitFirebase'

interface FirebaseServices {
  app: FirebaseApp
  auth: ReturnType<typeof getAuth>
  firestore: Firestore
  functions: Functions
  storage: FirebaseStorage
}

let verified:
  | { appName: string; sessionId: string; targetUid: string }
  | undefined

export const primaryServices: FirebaseServices = {
  app: auth.app,
  auth,
  firestore,
  functions,
  storage,
}

export const activateEffectiveServices = (
  app: FirebaseApp,
  sessionId: string,
  targetUid: string,
): void => {
  if (getAuth(app).currentUser?.uid !== targetUid) {
    throw new Error('Cannot activate services for an unverified target user.')
  }
  verified = { appName: app.name, sessionId, targetUid }
}

export const clearEffectiveServices = (): void => {
  verified = undefined
}

export const getEffectiveServices = (): FirebaseServices => {
  if (!verified) return primaryServices
  const app = getApps().find((candidate) => candidate.name === verified!.appName)
  if (!app || getAuth(app).currentUser?.uid !== verified.targetUid) {
    throw new Error('Verified effective Firebase services are unavailable.')
  }
  return {
    app,
    auth: getAuth(app),
    firestore: getFirestore(app),
    functions: getFunctions(app),
    storage: getStorage(app),
  }
}

export const getVerifiedServiceBinding = () =>
  verified ? { ...verified } : undefined
